export enum Mode {
  Normal = 'normal',
  Analysis = 'analysis'
}



// WEBPACK FOOTER //
// ./app/javascript/enums.ts